import Vue from 'vue'
import Vuex from 'vuex'
import _get from 'lodash/get'
import _cloneDeep from 'lodash/cloneDeep'
import axios from 'axios'
import { Notification } from 'element-ui'

Vue.use(Vuex)

const types = {
  SET_SITE_CONFIG: 'SET_SITE_CONFIG',
  SET_WIDGET_OPTIONS: 'SET_WIDGET_OPTIONS',
  SET_ALL_JOBS: 'SET_ALL_JOBS',
  SET_CURRENT_JOB: 'SET_CURRENT_JOB',
  SET_SEGMENTS: 'SET_SEGMENTS',
  SET_SEGMENT_GROUPS: 'SET_SEGMENT_GROUPS',
  SET_SUGGESTIONS: 'SET_SUGGESTIONS'
}
export default new Vuex.Store({
  state: {
    siteConfig: {},
    widgetOptions: {},
    allJobs: {},
    currentJob: {},
    segments: {},
    segments_groups: {},
    suggestions: {}
  },
  mutations: {
    [types.SET_SITE_CONFIG]: (state, value) => {
      state.siteConfig = value
    },
    [types.SET_WIDGET_OPTIONS]: (state, value) => {
      state.widgetOptions = value
    },
    [types.SET_ALL_JOBS]: (state, value) => {
      state.allJobs = value
    },
    [types.SET_CURRENT_JOB]: (state, value) => {
      state.currentJob = value
    },
    [types.SET_SEGMENTS]: (state, value) => {
      state.segments = value
    },
    [types.SET_SEGMENT_GROUPS]: (state, value) => {
      state.segments_groups = value
    },
    [types.SET_SUGGESTIONS]: (state, value) => {
      state.suggestions = value
    }
  },
  actions: {
    async getJobs({ commit, state }, params) {
      try {
        const res = await axios.get(`/api/public/v1/job-boards/${state.widgetOptions.JOB_BOARD_ID}/jobs?&limit=${state.widgetOptions.JOBS_PER_PAGE}`, { params })
        commit(types.SET_ALL_JOBS, res.data)
        return res.data
      } catch (e) {
        Notification.error({ message: 'Something went wrong', dangerouslyUseHTMLString: true })
      }
    },
    async getJobBySlug({ commit }, slug) {
      try {
        const res = await axios.get(`/api/public/v1/jobs/slug/${slug}`)
        commit(types.SET_CURRENT_JOB, res.data.data)
        return res.data.data
      } catch (e) {
        Notification.error({ message: 'Something went wrong', dangerouslyUseHTMLString: true })
      }
    },
    async getConfig({ commit }) {
      try {
        const res = await axios.get(`/api/public/v1/configuration/`)
        commit(types.SET_SEGMENTS, res.data.segments)
        commit(types.SET_SEGMENT_GROUPS, res.data.segments_groups)
        commit(types.SET_SITE_CONFIG, res.data)
        return res.data
      } catch (e) {
        Notification.error({ message: 'Something went wrong', dangerouslyUseHTMLString: true })
      }
    },
    async getSuggestions({ commit }) {
      try {
        const res = await axios.get(`/api/public/v1/job-boards/1/suggestions`)
        commit(types.SET_SUGGESTIONS, res.data)
        return res.data
      } catch (e) {
        Notification.error({ message: 'Something went wrong', dangerouslyUseHTMLString: true })
      }
    }
  },
  getters: {
    getSegmentByGroupAndId: (state) => (group, id) => {
      let segmentGroup = _get(state, ['segments', group], [])
      return segmentGroup.find(s => s.id === id) || {}
    },
    getAllSegmentsGroup: state => {
      let res = state.segments_groups
      if (!res[0]) {
        return
      }
      return res.filter(s => {
        return s.jobs === true
      })
    },
    getAllSegments: state => {
      return state.segments
    },
    getSegmentGroup: (state, getters) => (param) => {
      const sGroups = getters.segments_groups['jobs'] || getters.getAllSegmentsGroup
      return sGroups.find(g => g.id === param || g.key === param) || {}
    },
    getSegmentsById: (state, getters) => {
      const segmentsById = {}
      for (let key of Object.keys(getters.getAllSegments)) {
        for (let segment of getters.getAllSegments[key]) {
          segmentsById[segment.id] = segment
        }
      }
      return segmentsById
    },
    getJobById: (state) => (slug) => {
      return state.allJobs.data.filter(j => j.slug === slug)
    },
    countries: state => {
      let countries = _get(state, 'siteConfig.countries', [])
      let clonedCountries = _cloneDeep(countries)
      clonedCountries = clonedCountries.filter(c => c.active)

      if (!clonedCountries.length) {
        return countries.filter(c => c.primary) || []
      }

      return clonedCountries || []
    },
    widgetConfig: state => state.widgetOptions,
    jobsPerPage: state => state.widgetOptions.JOBS_PER_PAGE,
    getCurrentJob: state => state.currentJob,
    gaKey: state => state.widgetOptions.GA_KEY,
    getPrimaryColor: state => state.widgetOptions.PRIMARY_COLOR,
    getCurrentLanguage: state => state.widgetOptions.LANGUAGE,
    getNewsletters: state => state.siteConfig.newsletters,
    getTermsAndConditions: state => _get(state, 'siteConfig.settings', []),
  },
  modules: {}
})
